






























import Vue from "vue";

import IconRestart from "../../assets/icons/transparent/Rewind.svg";
import IconPause from "../../assets/icons/white/Pause.svg";
import IconPlay from "../../assets/icons/white/Play.svg";

import { AudioPlayerStatus } from "../../models/audio";

interface Props {
  status: AudioPlayerStatus;
  disabled: boolean;
  iconRestart: string;
  iconPause: string;
  iconPlay: string;
}

/**
 * @emits demo-restart
 * @emits demo-pause
 * @emits demo-play
 */
export default Vue.extend<Props>({
  name: "JzMicController",
  functional: true,
  props: {
    status: { type: String as () => AudioPlayerStatus, required: true },
    disabled: { type: Boolean, default: false },
    iconRestart: { type: String, default: IconRestart },
    iconPause: { type: String, default: IconPause },
    iconPlay: { type: String, default: IconPlay }
  }
});
